import { Component, OnInit, AfterViewInit } from "@angular/core";
import { serviceUrl } from "../common/serviceconstants";
import { Router } from "@angular/router";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
//import { RequestOptions, Headers, URLSearchParams, Http } from "@angular/http";
import { LoadingComponent, LoaderService } from "../services/loader.service";
import { EmitterService } from "../emitterservice";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit, AfterViewInit {
  userID: any = "";
  Password: any = "";
  disMessage: any = "";
  public resData: any = {};
  Username: any = "";
  Email: any = "";
  adisable: any = true;

  constructor(
    private http: HttpClient,
    private router: Router,
    private loaderservice: LoaderService
  ) {
    this.loaderservice.display(false);
  }

  ngOnInit() {

  }
  ngAfterViewInit() {
    // setTimeout(() => {
    //   document.getElementById("g-recaptcha-response").setAttribute("aria-label", "Recaptcha response");
    // }, 1000);
  }

  clear() {
    this.userID = "";
    this.Password = "";
  }

  resolved(event) {
    this.adisable = false;
  }

  validateUser() {
    this.disMessage = "";
    this.loaderservice.display(true);
    const hdrs = new HttpHeaders({ "Content-Type": "application/json" });

    if (!(this.userID.length > 0) && !(this.Password.length > 0)) {
      this.disMessage = "Email / Password is required";
      this.loaderservice.display(false);
      return;
    } else {
      if (!(this.userID.length > 0)) {
        this.disMessage = "Email is required";
        this.loaderservice.display(false);
        return;
      } else if (!(this.Password.length > 0)) {
        this.disMessage = "Password is required";
        this.loaderservice.display(false);
        return;
      }
    }

    this.http
      .post<any>(
        serviceUrl + "/User/ValidateUser",
        {
          userID: this.userID,
          userPwd: this.Password
        },
        { headers: hdrs }
      )
      .subscribe(
        res => {
          this.resData = res;
          //this.clear();

          if (
            this.resData.UserID === "" ||
            this.resData == undefined ||
            this.resData.UserID == undefined
          ) {
            this.disMessage = "Not a Valid user";
            sessionStorage.removeItem("Username");
            sessionStorage.removeItem("UserID");
            sessionStorage.removeItem("Email");
            sessionStorage.removeItem("RoleName");
            sessionStorage.removeItem("RoleId");
            sessionStorage.removeItem("Admin");
            sessionStorage.removeItem("Active");
            this.loaderservice.display(false);
          } else {
            this.Username = this.resData.Username;
            this.userID = this.resData.Email;
            this.Email = this.resData.Email;
            sessionStorage.setItem("Username", this.Username);
            sessionStorage.setItem("UserID", this.userID);
            sessionStorage.setItem("Email", this.Email);
            sessionStorage.setItem("Admin", this.resData.Admin);
            sessionStorage.setItem("RoleName", this.resData.RoleName);
            sessionStorage.setItem("RoleId", this.resData.RoleId);
            sessionStorage.setItem("Active", this.resData.Active);
            sessionStorage.setItem(
              "AuthorizedToken",
              this.resData.AuthorizedToken
            );
            this.Username = sessionStorage.getItem("Username");
            this.userID = sessionStorage.getItem("UserID");
            this.Email = sessionStorage.getItem("Email");
            this.loaderservice.display(false);
            EmitterService.get("userlogin").emit(true);
            this.disMessage = "Valid user";
            if (this.resData.OutPutMessage === "") {
              this.router.navigateByUrl("/Employeeoutprocessing");
            } else {
              // this.disMessage = this.resData.OutPutMessage;
              this.disMessage = "Invalid credentials. Please try again";
              this.userID = "";
            }
          }
        },
        err => {
          this.loaderservice.display(false);
          this.disMessage = "Invalid credentials. Please try again";
        }
      );
  }
}
